<template>
  <Dialog
    v-model:visible="isVisible"
    :style="{ width: '400px', marginRight: '10px', marginLeft: '10px' }"
    header="Extract Vocabulary"
    :modal="true"
    @hide="resetForm"
  >
    <div class="dialog-content">
      <div class="field">
        <label
          for="level"
          class="block mb-2"
        >
          Japanese Level
        </label>
        <Dropdown
          id="level"
          v-model="settings.level"
          :options="japaneseLevel"
          option-label="label"
          option-value="value"
          placeholder="Select a level"
          class="w-full"
        />
      </div>

      <div class="field">
        <label
          for="topic"
          class="block mb-2"
        >
          Topic (Optional)
        </label>
        <InputText
          id="topic"
          v-model="settings.topic"
          type="text"
          class="w-full"
          placeholder="Enter topic"
        />
      </div>

      <div class="field">
        <p class="text-sm text-gray-600">
          <i class="pi pi-info-circle" />
          Vocabulary will be extracted from page {{ currentPage }}
        </p>
      </div>
    </div>

    <template #footer>
      <Button
        label="Cancel"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeDialog"
      />
      <Button
        label="Extract Vocabulary"
        icon="pi pi-check"
        :loading="isLoading"
        @click="submitForm"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

export default {
  name: 'VocabularyExtractionDialog',
  components: {
    Dialog,
    Dropdown,
    InputText,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  emits: ['hide', 'extract'],
  data() {
    return {
      isLoading: false,
      japaneseLevel: [
        { label: 'Beginner', value: 'beginner' },
        { label: 'Intermediate', value: 'intermediate' },
        { label: 'Advanced', value: 'advanced' },
      ],
      settings: {
        level: null,
        topic: '',
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('hide');
        }
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit('hide');
    },
    resetForm() {
      this.settings = {
        level: null,
        topic: '',
      };
    },
    async submitForm() {
      if (!this.settings.level) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please select a Japanese level',
          life: 3000,
        });
        return;
      }

      this.isLoading = true;
      try {
        this.$emit('extract', {
          level: this.settings.level,
          topic: this.settings.topic || null,
        });
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.w-full {
  width: 100%;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-gray-600 {
  color: #4b5563;
}

:deep(.p-inputtext) {
  padding: 0.5rem;
  border: 1px solid #d5d8dd;
  border-radius: 0.25rem;
}

:deep(.p-dropdown) {
  width: 100%;
}
</style>
